import styled, { css } from 'styled-components'

import { shimmer } from '@/theme/animations'

import { SkeletonVariant, SpacingKey } from './skeleton.types'

const variantStyles: Record<SkeletonVariant, ReturnType<typeof css>> = {
  circular: css`
    border-radius: 50%;
  `,
  rectangular: css`
    border-radius: 0.8rem;
  `,
  text: css`
    border-radius: 0.4rem;
    height: 1.4rem;
    width: 100%;
  `,
}

export const Skeleton = styled.span<{
  $variant: SkeletonVariant
  $width: string
  $height: string
  $mt?: SpacingKey
  $mb?: SpacingKey
}>(
  ({ theme, $variant, $width, $height, $mt, $mb }) => css`
    display: block;
    flex-shrink: 0;
    background: linear-gradient(
      90deg,
      ${theme.colors.gray400} 25%,
      ${theme.colors.gray300} 50%,
      ${theme.colors.gray400} 75%
    );
    background-size: 200% 100%;
    animation: ${shimmer} 1.5s infinite linear;
    ${variantStyles[$variant]}
    width: ${$width};
    height: ${$height};
    ${$mt ? `margin-top: ${theme.space[$mt]};` : ''}
    ${$mb ? `margin-bottom: ${theme.space[$mb]};` : ''}
    border-radius: ${theme.border.radius['4']};
  `,
)
